export default {"src":"/_next/static/media/Group-25833.c0dad25e.svg","height":130,"width":130};